export enum WorkingStatus {
  Working = 'Working',
  Retired = 'Retired',
}
